<template>
    <div class="">

        <span class="price-start"
            v-html="getPriceText"></span>

        <span class="more-price-info"> 
        / Woche <br/>
        </span>

    </div>

</template>
<script>
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';

    export default {
    	voVueComponent: 'minrent',
    	props: {
    		pricelist: Array,
    		minrent: Number
    	},
    	data: function() {
    		return {
    			totalStars: 5
    		};
    	},
    	computed: {
    		getPriceText: function() {
    			var priceText = '';
    			var minrentWeek = 0;
    			var priceCleaning = 0;
    			var total = 0;

    			console.log('Pricelist::', this.pricelist);
    			console.log('minRent::', this.minrent);

    			if (this.minrent && this.pricelist) {
    				minrentWeek = this.minrent * 7;

    				//priceText += 'minrent:' + minrentWeek;

    				total = minrentWeek;
    				for (var i = 0; i < this.pricelist.length; i++) {
    					console.log('this.type::' + this.pricelist[i].type);
    					console.log('id::' + this.pricelist[i].service);

    					if (this.pricelist[i].type == 'FINALCLEANING' || this.pricelist[i].type == 'BOOKING_FEE') {
    						console.log('value adding::' + this.pricelist[i].value);
    						total = total + this.pricelist[i].value;
    						//priceText += ' cleaning:' + this.pricelist[i].value;
    					}


    					//total = minrentWeek + priceCleaning;
    				}
    				priceText += ' ab <span class="discount-price h3"><strong>';
    				priceText += Number(total / 100).toLocaleString("de-DE", {
    					minimumFractionDigits: 2
    				}) + " €";
    				priceText += '</span><strong>'

    			}

    			return priceText;
    		},
    		getMinRentText: function() {
    			var minRentText = '';

    			if (this.minrent) {
    				minRentText += Number(this.minrent / 100).toLocaleString("de-DE", {
    					minimumFractionDigits: 2
    				}) + " €";
    			}

    			return minRentText;
    		}
    	}
    };
</script>
<style scoped>
    .pricehelp {
    	font-size: 13px;
    	color: #666666;

    }
</style>